export const marqueeText =
  'DTCP Online Services are now available 24/7. Apply for Building Permissions, Layout Approvals, and Land Use Certificates online. Visit DPMS portal for all development permission applications. New GO on Building Permission fee revision effective from 01-01-2026.';

export const latestNews = [
  { title: 'DTCP launches online building permission system for all UDAs', date: '2026-03-20', category: 'General' },
  { title: 'New master plan for Visakhapatnam region approved', date: '2026-03-18', category: 'Planning' },
  { title: 'LRS applications now accepted online through DPMS', date: '2026-03-15', category: 'Services' },
  { title: 'DTCP conducts awareness program on building regulations', date: '2026-03-12', category: 'Events' },
  { title: 'Revised fee structure for building permissions notified', date: '2026-03-10', category: 'General' },
  { title: 'New regional office inaugurated in Kurnool', date: '2026-03-08', category: 'General' },
];

export const circulars = [
  { title: 'Circular on revised building permission process', date: '2026-03-19', ref: 'DTCP/Circ/2026/045' },
  { title: 'Guidelines for LTP registration renewal', date: '2026-03-15', ref: 'DTCP/Circ/2026/042' },
  { title: 'Procedure for layout approval in UDA areas', date: '2026-03-12', ref: 'DTCP/Circ/2026/039' },
  { title: 'Instructions on master plan implementation', date: '2026-03-08', ref: 'DTCP/Circ/2026/036' },
  { title: 'Clarification on regularization scheme eligibility', date: '2026-03-05', ref: 'DTCP/Circ/2026/033' },
  { title: 'Updated documentation requirements for BPS', date: '2026-03-01', ref: 'DTCP/Circ/2026/030' },
];

export const tenders = [
  { title: 'Tender for GIS mapping of Vijayawada master plan area', date: '2026-03-22', ref: 'DTCP/T/2026/018', status: 'Open' as const },
  { title: 'Supply and installation of IT infrastructure', date: '2026-03-18', ref: 'DTCP/T/2026/016', status: 'Open' as const },
  { title: 'Consultancy for Tirupati master plan revision', date: '2026-03-14', ref: 'DTCP/T/2026/014', status: 'Closing Soon' as const },
  { title: 'Digitization of old building permission records', date: '2026-03-10', ref: 'DTCP/T/2026/012', status: 'Open' as const },
  { title: 'Annual maintenance of DPMS portal', date: '2026-03-05', ref: 'DTCP/T/2026/010', status: 'Closed' as const },
  { title: 'Procurement of survey equipment for UDAs', date: '2026-03-01', ref: 'DTCP/T/2026/008', status: 'Closed' as const },
];

export const importantNotices = [
  { title: 'Last date for LRS applications extended to 31-03-2026', urgent: true },
  { title: 'Building permission fee payment deadline reminder', urgent: true },
  { title: 'DPMS portal scheduled maintenance on 28-03-2026', urgent: false },
  { title: 'New documentation checklist for layout approvals', urgent: false },
  { title: 'Holiday list for DTCP offices - March 2026', urgent: false },
  { title: 'Revised working hours for regional offices', urgent: false },
  { title: 'Online training sessions for LTP registration', urgent: false },
];
